import React from 'react'
import { useFormContext } from 'react-hook-form'

import { FormFieldFormTemplateMappingSource, FormTemplateMappingFormValues, FormTemplateMappingTarget } from '../../../../models/FormTemplate'
import { Descriptor, UiSchemaDescriptor } from '../../../../models/Scorecard'

import { mappingExistsForSource } from '../utils'

import { FormFieldFormTemplateMappingSourceColumn } from './FormTemplateMappingSourceColumn'
import { FormTemplateMappingTargetColumn } from './FormTemplateMappingTargetColumn'

interface MultipleChoiceFormFieldFormTemplateMappingRowsProps {
  descriptor: Descriptor
  descriptorOptions: string[]
  uiSchemaDescriptor?: UiSchemaDescriptor
  targets: FormTemplateMappingTarget[]
  source: FormFieldFormTemplateMappingSource
  showUnmappedOnly: boolean
}

export const MultipleChoiceFormFieldFormTemplateMappingRows: React.FC<MultipleChoiceFormFieldFormTemplateMappingRowsProps> = ({
  descriptor,
  descriptorOptions,
  uiSchemaDescriptor,
  targets,
  source,
  showUnmappedOnly,
}) => {
  const { watch } = useFormContext<FormTemplateMappingFormValues>()

  const mapping = watch('mapping')

  const filteredOptions = showUnmappedOnly ? descriptorOptions.filter((option) => !mappingExistsForSource({ ...source, option }, mapping)) : descriptorOptions

  return (
    <>
      <div className='d-flex align-items-center border-top zocks-border-color-gray-200 form-template-mapping-row'>
        <FormFieldFormTemplateMappingSourceColumn descriptor={descriptor} uiSchemaDescriptor={uiSchemaDescriptor} showSpacer={true} />
        <div className='w-50 d-flex flex-column px-3 zocks-py-0.75'>
          <span className='paragraph-medium zocks-text-gray-700 py-2'>Match each choice to a PDF field:</span>
        </div>
      </div>
      {filteredOptions.map((option) => (
        <div
          key={`multiple-choice-form-field-form-template-mapping-row-${source.path}-${option}`}
          className='d-flex align-items-center zocks-border-color-gray-200 form-template-mapping-row'
        >
          <FormFieldFormTemplateMappingSourceColumn descriptor={descriptor} uiSchemaDescriptor={uiSchemaDescriptor} option={option} />
          <FormTemplateMappingTargetColumn targets={targets} source={{ ...source, option }} />
        </div>
      ))}
    </>
  )
}
